import { AboFilterI } from 'src/adminPanel/components/pages/office/AboSubscriptionFilter';
import { PageableQueryParams } from 'src/entities/basic-types/Pageable';
import { action } from '../actions';

export const FETCH_ABO_TEMPLATES_BY_CUSTOMER_ID = 'FETCH_ABO_TEMPLATES_BY_CUSTOMER_ID';
export const REQUEST_FETCH_ABO_TEMPLATES_BY_CUSTOMER_ID = 'REQUEST_FETCH_ABO_TEMPLATES_BY_CUSTOMER_ID';
export const SUCCESS_FETCH_ABO_TEMPLATES_BY_CUSTOMER_ID = 'SUCCESS_FETCH_ABO_TEMPLATES_BY_CUSTOMER_ID';
export const FAILURE_FETCH_ABO_TEMPLATES_BY_CUSTOMER_ID = 'FAILURE_FETCH_ABO_TEMPLATES_BY_CUSTOMER_ID';

export const fetchAboTemplatesByCustomerId = (customerId: string | number, pageable: PageableQueryParams) =>
    action(FETCH_ABO_TEMPLATES_BY_CUSTOMER_ID, { customerId, pageable });
export const requestFetchAboTemplatesByCustomerId = () => action(REQUEST_FETCH_ABO_TEMPLATES_BY_CUSTOMER_ID);
export const requestFetchAboTemplatesByCustomerIdSuccess = (response: any) =>
    action(SUCCESS_FETCH_ABO_TEMPLATES_BY_CUSTOMER_ID, { response });
export const requestFetchAboTemplatesByCustomerIdFailure = (error: any) =>
    action(FAILURE_FETCH_ABO_TEMPLATES_BY_CUSTOMER_ID, { error });

export const FETCH_ABO_SUBSCRIPTION_ORDER_PRODUCTS = 'FETCH_ABO_SUBSCRIPTION_ORDER_PRODUCTS';
export const REQUEST_FETCH_ABO_SUBSCRIPTION_ORDER_PRODUCTS = 'REQUEST_FETCH_ABO_SUBSCRIPTION_ORDER_PRODUCTS';
export const SUCCESS_FETCH_ABO_SUBSCRIPTION_ORDER_PRODUCTS = 'SUCCESS_FETCH_ABO_SUBSCRIPTION_ORDER_PRODUCTS';
export const FAILURE_FETCH_ABO_SUBSCRIPTION_ORDER_PRODUCTS = 'FAILURE_FETCH_ABO_SUBSCRIPTION_ORDER_PRODUCTS';

export const fetchAboSubscriptionOrderProducts = () => action(FETCH_ABO_SUBSCRIPTION_ORDER_PRODUCTS, {});
export const requestFetchAboSubscriptionOrderProducts = () => action(REQUEST_FETCH_ABO_SUBSCRIPTION_ORDER_PRODUCTS);
export const requestFetchAboSubscriptionOrderProductsSuccess = (response: any) =>
    action(SUCCESS_FETCH_ABO_SUBSCRIPTION_ORDER_PRODUCTS, { response });
export const requestFetchAboSubscriptionOrderProductsFailure = (error: any) =>
    action(FAILURE_FETCH_ABO_SUBSCRIPTION_ORDER_PRODUCTS, { error });

export const INSERT_ABO_SUBSCRIPTION = 'INSERT_ABO_SUBSCRIPTION';
export const REQUEST_INSERT_ABO_SUBSCRIPTION = 'REQUEST_INSERT_ABO_SUBSCRIPTION';
export const SUCCESS_INSERT_ABO_SUBSCRIPTION = 'SUCCESS_INSERT_ABO_SUBSCRIPTION';
export const FAILURE_INSERT_ABO_SUBSCRIPTION = 'FAILURE_INSERT_ABO_SUBSCRIPTION';

export const insertAboSubscription = (aboSubscription: any) => action(INSERT_ABO_SUBSCRIPTION, { aboSubscription });
export const requestInsertAboSubscription = () => action(REQUEST_INSERT_ABO_SUBSCRIPTION);
export const requestInsertAboSubscriptionSuccess = (response: any) =>
    action(SUCCESS_INSERT_ABO_SUBSCRIPTION, { response });
export const requestInsertAboSubscriptionFailure = (error: any) => action(FAILURE_INSERT_ABO_SUBSCRIPTION, { error });

export const UPDATE_ABO_SUBSCRIPTION = 'UPDATE_ABO_SUBSCRIPTION';
export const REQUEST_UPDATE_ABO_SUBSCRIPTION = 'REQUEST_UPDATE_ABO_SUBSCRIPTION';
export const SUCCESS_UPDATE_ABO_SUBSCRIPTION = 'SUCCESS_UPDATE_ABO_SUBSCRIPTION';
export const FAILURE_UPDATE_ABO_SUBSCRIPTION = 'FAILURE_UPDATE_ABO_SUBSCRIPTION';

export const updateAboSubscription = (aboSubscription: any) => action(UPDATE_ABO_SUBSCRIPTION, { aboSubscription });
export const requestUpdateAboSubscription = () => action(REQUEST_UPDATE_ABO_SUBSCRIPTION);
export const requestUpdateAboSubscriptionSuccess = (response: any) =>
    action(SUCCESS_UPDATE_ABO_SUBSCRIPTION, { response });
export const requestUpdateAboSubscriptionFailure = (error: any) => action(FAILURE_UPDATE_ABO_SUBSCRIPTION, { error });

export const FETCH_ABO_TEMPLATES_BY_CUSTOMER_ID_AND_FILTER = 'FETCH_ABO_TEMPLATES_BY_CUSTOMER_ID_AND_FILTER';
export const REQUEST_FETCH_ABO_TEMPLATES_BY_CUSTOMER_ID_AND_FILTER =
    'REQUEST_FETCH_ABO_TEMPLATES_BY_CUSTOMER_ID_AND_FILTER';
export const SUCCESS_FETCH_ABO_TEMPLATES_BY_CUSTOMER_ID_AND_FILTER =
    'SUCCESS_FETCH_ABO_TEMPLATES_BY_CUSTOMER_ID_AND_FILTER';
export const FAILURE_FETCH_ABO_TEMPLATES_BY_CUSTOMER_ID_AND_FILTER =
    'FAILURE_FETCH_ABO_TEMPLATES_BY_CUSTOMER_ID_AND_FILTER';

export const fetchAboTemplatesByFilter = (pageable: PageableQueryParams, filter: AboFilterI) =>
    action(FETCH_ABO_TEMPLATES_BY_CUSTOMER_ID_AND_FILTER, { pageable, filter });
export const requestFetchAboTemplatesByFilter = () => action(REQUEST_FETCH_ABO_TEMPLATES_BY_CUSTOMER_ID_AND_FILTER);
export const requestFetchAboTemplatesByFilterSuccess = (response: any) =>
    action(SUCCESS_FETCH_ABO_TEMPLATES_BY_CUSTOMER_ID_AND_FILTER, { response });
export const requestFetchAboTemplatesByFilterFailure = (error: any) =>
    action(FAILURE_FETCH_ABO_TEMPLATES_BY_CUSTOMER_ID_AND_FILTER, { error });

export const FETCH_ABO_TEMPLATE_BY_ID = 'FETCH_ABO_TEMPLATE_BY_ID';
export const REQUEST_FETCH_ABO_TEMPLATE_BY_ID = 'REQUEST_FETCH_ABO_TEMPLATE_BY_ID';
export const SUCCESS_FETCH_ABO_TEMPLATE_BY_ID = 'SUCCESS_FETCH_ABO_TEMPLATE_BY_ID';
export const FAILURE_FETCH_ABO_TEMPLATE_BY_ID = 'FAILURE_FETCH_ABO_TEMPLATE_BY_ID';

export const fetchAboTemplateById = (templateId: string) => action(FETCH_ABO_TEMPLATE_BY_ID, { templateId });
export const requestFetchAboTemplateById = () => action(REQUEST_FETCH_ABO_TEMPLATE_BY_ID);
export const requestFetchAboTemplateByIdSuccess = (response: any) =>
    action(SUCCESS_FETCH_ABO_TEMPLATE_BY_ID, { response });
export const requestFetchAboTemplateByIdFailure = (error: any) => action(FAILURE_FETCH_ABO_TEMPLATE_BY_ID, { error });
